const block_icons     = {
  flat_icon:                 <svg
  xmlns="http://www.w3.org/2000/svg"
  x="0"
  y="0"
  enableBackground="new 0 0 512 512"
  version="1.1"
  viewBox="0 0 512 512"
  xmlSpace="preserve"
>
  <g fill="#FD003A">
    <path d="M258.499 512a15 15 0 01-12.745-7.091L102.869 274.652C85.289 246.26 76 213.534 76 180 76 80.748 156.748 0 256 0s180 80.748 180 180c0 32.539-8.779 64.428-25.389 92.22L271.368 504.707a15 15 0 01-12.75 7.292l-.119.001zM256 30c-82.71 0-150 67.29-150 150 0 27.95 7.734 55.214 22.368 78.846l129.905 209.34 126.594-211.368C398.689 233.688 406 207.121 406 180c0-82.71-67.29-150-150-150z"></path>
    <path d="M256 270c-31.397 0-60.044-15.977-76.631-42.737C170.62 213.117 166 196.778 166 180c0-49.626 40.374-90 90-90s90 40.374 90 90c0 16.284-4.371 32.209-12.639 46.055C316.913 253.574 287.994 270 256 270zm0-150c-33.084 0-60 26.916-60 60 0 11.2 3.069 22.082 8.875 31.47C215.945 229.33 235.06 240 256 240c21.337 0 40.629-10.965 51.607-29.331 5.49-9.193 8.393-19.8 8.393-30.669 0-33.084-26.916-60-60-60z"></path>
  </g>
</svg>
}

export default block_icons;